import React, {useState, useEffect} from "react";
import axios from "axios";

// Importing images
import logo from "../assets/img/logo.webp";
import BoucMediaWhite from "../assets/img/BoucMedia_White_3_1296x.webp";
import Layout from "./Label";

function ExampleReactComponent() {
    const [pageData, setPageData] = useState(null); // Для хранения данных страницы
    const [loading, setLoading] = useState(true); // Для отслеживания состояния загрузки

    useEffect(() => {
        // Запрос к REST API
        axios
            .get("/wp-json/wp/v2/pages/53")
            .then((response) => {
                setPageData(response.data); // Устанавливаем данные страницы
                setLoading(false); // Завершаем загрузку
            })
            .catch((error) => {
                console.error("Error fetching the page data:", error);
                setLoading(false);
            });
    }, []); // Пустой массив зависимостей означает, что запрос выполняется только один раз

    if (loading) {
        return <div>Loading...</div>; // Пока данные загружаются
    }

    if (!pageData) {
        return <div>Error loading page data</div>; // Если данные не были получены
    }

    return (<Layout>
        <section className="page">
            <div className="container ">
                <div className="page-text ">
                    <div className="section-header text-center">
                        <h1 style={{fontSize: "4rem"}}>{pageData.title.rendered}</h1>
                    </div>
                    <div
                        className="our-services-content our-services-content-center"
                        dangerouslySetInnerHTML={{__html: pageData.content.rendered}}
                    ></div>


                    <form method="post"  autoComplete="off" action="/contact#contact_form" id="contact_form" accept-charset="UTF-8"
                          className="contact-form">
                        <input type="hidden" name="form_type" value="contact"/>
                        <input type="hidden" name="utf8" value="✓"/>


                        <div className="grid">
                            <div className="grid__item medium-up--one-half">
                                <label htmlFor="ContactFormName" className="label--hidden">Name</label>
                                <input autoComplete="off" type="text" id="ContactFormName" name="contact[Name]" placeholder="Name"
                                       autoCapitalize="words" value=""/>
                            </div>
                            <div className="grid__item medium-up--one-half">
                                <label htmlFor="ContactFormEmail" className="label--hidden">Email</label>
                                <input type="email" id="ContactFormEmail"  autoComplete="off" name="contact[email]" placeholder="Email"
                                       autoCorrect="off" autoCapitalize="off" value=""/>
                            </div>
                        </div>

                        <label htmlFor="ContactFormPhone" className="label--hidden">Phone Number</label>
                        <input type="tel" id="ContactFormPhone" name="contact[Phone Number]"
                               placeholder="Phone Number" pattern="[0-9\-]*" value=""/>

                        <label htmlFor="ContactFormMessage" className="label--hidden">Message</label>
                        <textarea rows="6" id="ContactFormMessage" name="contact[Message]"
                                  placeholder="Message"></textarea>

                        <input type="submit" className="btn btn-def" value="Send"/>
                    </form>
                </div>
            </div>
        </section>
    </Layout>);
}

export default ExampleReactComponent;
